import { ProcessTypeEnum } from './cartDetails/process-type.enum';
import SlotModel from './slot.model';

export default class StateModel {

  public ordinal: number;
  public processName: string;
  public tempProcessType: ProcessTypeEnum;
  public MNP_EDIT_STATE: boolean;
  public RETENTION_EDIT_STATE: boolean;
  public UPSELL_EDIT_STATE: boolean;
  public PREPAID_2_POSTPAID_EDIT_STATE: boolean;
  public msisdn: string;

  constructor(slot: SlotModel, isCustomerDataPresent: boolean) {

    const msisdn = slot.getMsisdn();
    const tempProcessType = slot.processType;

    this.ordinal = slot.ordinal;
    this.processName = slot.processType;
    this.tempProcessType = tempProcessType;
    this.MNP_EDIT_STATE = tempProcessType === ProcessTypeEnum.MNP && !msisdn;
    this.RETENTION_EDIT_STATE = tempProcessType === ProcessTypeEnum.RETENTION && !msisdn;
    this.UPSELL_EDIT_STATE = tempProcessType === ProcessTypeEnum.UPSELL && !isCustomerDataPresent;
    this.PREPAID_2_POSTPAID_EDIT_STATE = tempProcessType === ProcessTypeEnum.PREPAID_2_POSTPAID && !msisdn;
    this.msisdn = msisdn;
  }

}
